module.exports = __webpack_public_path__ + "static/media/03.2f8bb5fb.jpg";